import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetCashFundCurrenciesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetCashFundCurrenciesQuery = {
  __typename?: 'Query';
  getCashFundCurrencies: {
    __typename?: 'CashFundCurrenciesResult';
    currencyDescriptors: Array<{
      __typename?: 'CashFundCurrencyDescriptor';
      currencyCode: string;
      countryDescriptors?: Array<{ __typename?: 'CashFundCountryDescriptor'; countryCode: string }> | null;
    }>;
  };
};

export const GetCashFundCurrenciesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCashFundCurrencies' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCashFundCurrencies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currencyDescriptors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'countryDescriptors' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCashFundCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetCashFundCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashFundCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashFundCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCashFundCurrenciesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCashFundCurrenciesQuery, GetCashFundCurrenciesQueryVariables>) {
  return ApolloReactHooks.useQuery<GetCashFundCurrenciesQuery, GetCashFundCurrenciesQueryVariables>(GetCashFundCurrenciesDocument, baseOptions);
}
export function useGetCashFundCurrenciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCashFundCurrenciesQuery, GetCashFundCurrenciesQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetCashFundCurrenciesQuery, GetCashFundCurrenciesQueryVariables>(GetCashFundCurrenciesDocument, baseOptions);
}
export type GetCashFundCurrenciesQueryHookResult = ReturnType<typeof useGetCashFundCurrenciesQuery>;
export type GetCashFundCurrenciesLazyQueryHookResult = ReturnType<typeof useGetCashFundCurrenciesLazyQuery>;
export type GetCashFundCurrenciesQueryResult = Apollo.QueryResult<GetCashFundCurrenciesQuery, GetCashFundCurrenciesQueryVariables>;
